/* WARNING: This file is auto-generated. Do not edit directly.   */
/* To make changes, edit `lib/generators/constants_generator.rb` */
/* To regenerate, run: `rails g constants`                       */

import { ConstantsQuery } from 'queries';

export const DELAYED = 1;
export const FORFEIT = 2;
export const CANCELLED = 3;
export const POSTPONED = 4;

export type GameSecondaryStatusType = ConstantsQuery['game_secondary_statuses'][number];

const GAME_SECONDARY_STATUSES: GameSecondaryStatusType[] = [
  {
    id: DELAYED,
    name: 'Delayed'
  },
  {
    id: FORFEIT,
    name: 'Forfeit'
  },
  {
    id: CANCELLED,
    name: 'Cancelled'
  },
  {
    id: POSTPONED,
    name: 'Postponed'
  }
];

export default GAME_SECONDARY_STATUSES;
